import {Component, Input, OnInit} from '@angular/core';
import {QuestionComponent} from '../question.component';
import {ImageAsset, ImageAssetFactory, ImageAssetType} from '../../domain/card';
import {QuestionBase} from '../../domain/question.base';

@Component({
  selector: 'crds-question-general',
  template: `
    <div *ngIf="show" [formGroup]="form">
      <label *ngIf="question.label" class="form-label" [attr.for]="question.key">{{question.label}}
        <span *ngIf="question.required"> *</span>
        <crds-form-error *ngIf="isInvalid" [question]="question"
                         [message]="question.errorMessage"></crds-form-error>
      </label>
      <div *ngIf="question.value"
           class="text-question"
           [innerHtml]="question.value">
      </div>
      <!-- QUESTION HINT -->
      <crds-question-hint [question]="question"></crds-question-hint>

      <!-- QUESTION IMAGE -->
      <div class="image-wrapper">
        <crds-image-asset [images]="images" [key]="question.key"></crds-image-asset>
      </div>
    </div>`,
})
export class GeneralQuestionComponent extends QuestionComponent implements OnInit {
  @Input() form;
  @Input() question: QuestionBase<any>;
  type: string;
  images: ImageAsset[];
  imageAssetType = ImageAssetType;

  constructor(private imageAssetFactory: ImageAssetFactory) {
    super();
  }

  ngOnInit() {
    this.images = this.imageAssetFactory.create(this.question.image, this.form);
    if (this.question.key && this.question.value && !this.form.get(this.question.key).value) {
      this.form.get(this.question.key).patchValue(this.question.value);
    }
  }

  get isInvalid() {
    return this.form.get(this.question.key).touched && this.form.get(this.question.key).invalid;
  }

  get show() {
    const showIfQuestionPopulated = this.question.showIf ?
      this.showIf :
      true;
    return (this.question.showIfPopulated !== true || (this.value)) &&
      showIfQuestionPopulated && this.question.show !== false;
  }
}
